<template>
<div class="content bgimg-box" style="padding: 20px 30px" v-if="!uploaded">
  <!-- <div class="condition-box condition-video-box" style="margin-bottom: 20px;">
      <p>
        温馨提示： 请于2024.5.19上午10:00 前上传视频；
      </p>
    </div>
    <div class="condition-box condition-video-box">
      <h2 class="title">视频赛要求</h2>
      <p>
        1.入围中国大陆半决赛队伍需参加视频赛，内容需要体现团队各成员画面及GBC,  AICPA & CIMA或CGMA相关元素，每支队伍仅限上传一个视频<br />
        2.团队视频时长要求2分钟内，小于2GB， MP4格式, 横向拍摄<br />
        3.队长将视频上传至GBC官方报名平台，由公会于官方平台发起投票
      </p>
    </div> -->
  <div>
    <el-form label-width="96px">
      <!-- <el-form-item label="团队名称">
          <el-input v-model="newProcess.entries_name" placeholder="请输入团队名称"></el-input>
        </el-form-item> -->
      <!-- <el-form-item label="团队口号">
          <el-input type="textarea" rows="2" v-model="newProcess.introduce" placeholder="请输入团队口号"></el-input>
        </el-form-item> -->
      <!-- <el-form-item class="upform" label="团队照片" required >
          <span
            >（必填，要求：图片命名学校名称+队伍名称；格式jpg、png；大小≤2MB）</span
          >
          <el-upload
            class="avatar-uploader"
            :headers="uploadHeader"
            :action="imageUrl + '/user/upload'"
            :data="uploadData"
            :show-file-list="false"
            :on-success="handleAvatarSuccess2"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
          >
            <img v-if="newProcess.photo" :src="imageUrl + newProcess.photo" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item class="upform" label="封面设置">
          <span
            >（要求：图片命名学校名称+队伍名称;格式jpg、png;大小≤2MB;视频封面16:9，安全区域1:1）</span
          >
          <el-upload
            class="avatar-uploader"
            :headers="uploadHeader"
            :action="imageUrl + '/user/upload'"
            :data="uploadData"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
          >
            <img v-if="newProcess.entries_thumb" :src="imageUrl + newProcess.entries_thumb" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
      <!-- <el-form-item class="upform"  label="上传视频">
          <span class="ala-tip">视频赛 30 秒（仅限MP4/MOV/WMV格式）</span>
          <div class="video_box">
            <el-upload
            class="avatar-uploader avatar-uploader-video"
            :show-file-list="false"
            accept=".wmv, .asf, .asx, .rm, .rmvb, .mp4, .3gp, .mov, .m4v, .avi, .dat, .mkv, .flv, .vob"
            :action="'#'"
            :before-upload="(file)=>{beforeUpload(file)}"
            :http-request="(file)=>{uploadBefore(file)}"
            multiple
          >
            <div v-if="!fileInfo.url">
              <img src="../../assets/images/team/upload.png" alt="" />
              <p>点击上传</p>
              <el-progress :percentage="parseInt(jindu*100)" v-show="uploadVideoProgressShow" :color="customColor"></el-progress>
            </div>
            <div v-else style="height:100%">
              
              <video style="height:100%" autoplay controls :src="fileInfo.url"></video>
            </div>
            </el-upload>
            <div v-show="fileInfo.url" class="btn_del" @click="toDel">
                <i class="el-icon-close"></i>
              </div>
          </div>
          
        </el-form-item> -->
      <!-- <el-form-item>
          <div class="team-button-box">
            <el-button class="pre" size="small" type="primary" @click="next" v-loading="subLoading">提交</el-button>
          </div>
        </el-form-item> -->

    </el-form>
    <div class="member-info">
      <h1 style="margin-top: 0;">
        <span>家长同意书</span>
        <span class="download" @click="downloadTemplate">下载模板</span>
      </h1>
      <el-upload drag :headers="uploadHeader" :action="imageUrl + '/user/upload'" :data="uploadData" :file-list="fileList"
        :on-success="handleFileSuccess" :before-upload="beforeFileUpload" :on-exceed="handleExceed" :on-remove="handleRemove" :limit="1">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip" style="margin-top: 0;">文件大小不超过100Mb</div>
      </el-upload>
      <h1>成员信息</h1>
      <el-dialog title="添加成员" :visible.sync="dialogFormVisible">
        <div class="condition-box condition-video-box" style="margin-bottom: 30px;">
          <p>
            【温馨提示】本次赛事证书将仅发放至各小组队长处。为确保证书信息准确及后续查询，请各位队员在填写信息时务必保证真实、准确。
          </p>
        </div>
        <div class="form-box">
          <el-form :model="memberData" ref="form" label-width="125px" :rules="rules">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="真实姓名" prop="name">
                  <el-input v-model="memberData.name" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="姓名拼音" prop="name_pinyin">
                  <el-input v-model="memberData.name_pinyin" placeholder="请输入姓名拼音（如：Huang Dengpan）"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="性别" prop="sex" required>
                  <el-radio-group v-model="memberData.sex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="手机" prop="mobile">
                  <el-input v-model="memberData.mobile" placeholder="请输入手机"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="memberData.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="证件号" prop="id_card">
                  <div class="card-form-item">
                    <div class="left">
                      <el-select v-model="memberData.card_type" placeholder="证件类型">
                        <el-option v-for="item in cardType" :key="item.id" :value="item.id"
                          :label="item.name"></el-option>
                      </el-select>
                    </div>
                    <div class="right">
                      <el-input v-model="memberData.id_card" placeholder="请输入证件号"></el-input>
                    </div>
                  </div>
                </el-form-item>

              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="角色" prop="leader" required>
                  <el-radio-group v-model="memberData.leader">
                    <el-radio :label="1">队长</el-radio>
                    <el-radio :label="2">队员</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="学校" prop="school">
                  <el-input v-model="memberData.school" placeholder="请输入学校"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="所在学院" prop="university">
                  <el-input v-model="memberData.university" placeholder="请输入所在学院"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="在读年级" prop="grade">
                  <el-select v-model="memberData.grade" placeholder="请选择在读年级">
                    <el-option v-for="item in grades" :key="item.id" :value="item.id" :label="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item>
                  <el-button class="y-btn" @click="setMember" size="small" type="primary">确定</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-dialog>
      <el-table class="pc-table" :data="memberArr" style="margin-bottom: 10px">
        <el-table-column prop="name" label="姓名" min-width="100px" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="name_pinyin" label="姓名拼音" min-width="100px" show-overflow-tooltip> </el-table-column>
        <el-table-column label="角色" min-width="80px" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <el-tag style="background: #f4eff6; color: #733085">{{
              scope.row.leader === 1 ? "队长" : "队员"
              }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机" min-width="100px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="120px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="card_type" label="证件类型" width="100px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="id_card" label="证件号" min-width="150px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="school" label="学校" min-width="125px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="university" label="所在学院" min-width="125px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="grade" label="在读年级" width="100px" show-overflow-tooltip>
          <template #default="{ row }">
            {{ getGrade(row.grade) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="is_cima" label="身份" min-width="120px" show-overflow-tooltip align="center">
        <template slot-scope="scope">
          {{ scope.row.is_cima === 1 ? "在读CIMA方向班学生" : "无" }}
        </template>
      </el-table-column> -->
        <!-- <el-table-column prop="cima_sn" label="CIMA学员ID" min-width="80px" show-overflow-tooltip align="center">
      </el-table-column> -->
        <!-- <el-table-column header-align="center" align="center" prop="address_info" label="联系地址" min-width="120px"
        show-overflow-tooltip>
      </el-table-column> -->
        <el-table-column label="操作" width="120px" align="center">
          <template slot-scope="scope">
            <span class="edit" @click="toEdit(scope.row, scope.$index)">编辑</span>
            <span class="del" @click="del(scope.$index)">删除</span>
          </template>
        </el-table-column>
      </el-table> 
      <div class="mobile-list">
        <div class="item" v-for="(item, index) in memberArr" :key="index">
          <div class="info">
            <div class="label">姓名</div>
            <div class="value">{{ item.name }}</div>
          </div>
          <div class="info">
            <div class="label">姓名拼音</div>
            <div class="value">{{ item.name_pinyin }}</div>
          </div>
          <div class="info">
            <div class="label">手机</div>
            <div class="value">{{ item.mobile }}</div>
          </div>
          <div class="info">
            <div class="label">邮箱</div>
            <div class="value">{{ item.email }}</div>
          </div>
          <div class="info">
            <div class="label">证件类型</div>
            <div class="value">{{ item.card_type }}</div>
          </div>
          <div class="info">
            <div class="label">证件号</div>
            <div class="value">{{ item.id_card }}</div>
          </div>
          <div class="info">
            <div class="label">学校</div>
            <div class="value">{{ item.school }}</div>
          </div>
          <div class="info">
            <div class="label">所在学院</div>
            <div class="value">{{ item.university }}</div>
          </div>
          <!-- <div class="info">
          <div class="label">身份</div>
          <div class="value">{{ item.is_cima === 1 ? "在读CIMA方向班学生" : "无" }}</div>
        </div> -->
          <div class="info">
            <div class="label">在读年级</div>
            <div class="value">{{ getGrade(item.grade) }}</div>
          </div>
          <!-- <div class="info">
          <div class="label">CIMA学员ID</div>
          <div class="value">{{ item.cima_sn }}</div>
        </div> -->
          <!-- <div class="info">
          <div class="label">联系地址</div>
          <div class="value">{{ item.address_info }}</div>
        </div> -->
          <div class="tag">
            <el-tag style="background: #f4eff6; color: #733085">{{
              item.leader === 1 ? "队长" : "队员"
              }}</el-tag>
          </div>
          <div class="bottom-btn">
            <div class="btn" @click="toEdit(item, index)">编辑</div>
            <div class="btn" @click="del(index)">删除</div>
          </div>
        </div>
      </div>
      <h1>指导老师</h1>
      <el-button class="add-btn" type="text" @click="toAddTeacher()"
        icon="el-icon-circle-plus-outline">添加指导老师</el-button>
      <el-dialog  custom-class="dialog_tc" title="添加指导老师" :visible.sync="teacherDialog" width="480px">
        <div class="form-box rules-form">
          <el-form :model="teacherForm" ref="teacherForm" label-width="80px" :rules="teacherRules">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="teacherForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="teacherForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="id_card">
              <el-input v-model="teacherForm.id_card" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label-width="0px" style="text-align: center;margin-top: 20px;">
              <el-button style="margin-bottom: 0px;" class="y-btn" @click="setTeacher" size="small" type="primary">确定</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <el-table class="pc-table" :data="teacherData" style="margin-bottom: 10px">
        <el-table-column prop="name" label="姓名" min-width="100px" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="phone" label="手机" min-width="100px" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="id_card" label="身份证号" min-width="100px" show-overflow-tooltip align="center">
      </el-table-column>
        <el-table-column label="操作" width="120px" align="center">
          <template slot-scope="scope">
            <span class="edit" @click="toEditTeacher(scope.row, scope.$index)">编辑</span>
            <span class="del" @click="delTeacher(scope.$index)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="mobile-list">
        <div class="item" v-for="(item, index) in teacherData" :key="index">
          <div class="info">
            <div class="label">姓名</div>
            <div class="value">{{ item.name }}</div>
          </div>
          <div class="info">
            <div class="label">手机</div>
            <div class="value">{{ item.phone }}</div>
          </div>
          <!-- <div class="info">
          <div class="label">身份证号</div>
          <div class="value">{{ item.id_card }}</div>
        </div> -->
          <div class="bottom-btn">
            <div class="btn" @click="toEditTeacher(item, index)">编辑</div>
            <div class="btn" @click="delTeacher(index)">删除</div>
          </div>
        </div>
      </div>
			<div class="team-button-box" style="text-align: center;">
				<el-button  @click="submit" size="small" type="primary" :loading="operateLoading">提交</el-button>
			</div>
    </div>
  </div>
</div>
<div class="status-box" v-else>
  <div class="img-box">
    <img src="../../assets/images/success.png" style="width: 240px;" alt="" />
    <p>感谢提交信息，期待我们5月28日（周四）相约在美丽的广东外语外贸大学（白云山校区: 中国广州市白云区白云大道北2号）</p>
    <el-button style="margin-top: 30px;" @click="uploaded = false">编辑信息</el-button>
  </div>
</div>
</template>

<script>
import {
  apiGetOssConfig,
  apiUploadFileInfo,
  apiSetProcess,
  apiGetProcess,
  apiGetReportTeamData,
  apiGetSemiFinalInfo,
  apiSubSemiFinalInfo
} from '../../plugins/apis'
import OSS from "ali-oss";

export default {
  data() {
    return {
      uploaded: false,
      imageUrl: process.env.VUE_APP_API_URL,
      uploadHeader: { Authorization: window.localStorage.cima_registration_token },
      newProcess: {},
      fileInfo: {
        url: ''
      },
      team: null,
      uploadData: { file_source: 1 },
      jindu: 0,
      size: '',
      uploadVideoProgressShow: false,
      customColor: '#733085',
      subLoading: false,
      form: {
        parent_path: '',
      },
      
			memberData: {
				name: "",
				sex: 1,
				school: "",
				university: "",
				grade: "",
				mobile: "",
				email: "",
				leader: 2,
			},
      memberArr: [],
			rules: {
				name: [
					{
						required: true,
						message: "请输入真实姓名",
						trigger: ["blur", "change"],
					},
				],
				name_pinyin: [
					{
						required: true,
						message: "请输入姓名拼音",
						trigger: ["blur", "change"],
					},
				],
				mobile: [
					{
						required: true,
						validator: (rule, value, callback) => {
							let mobileNumRegx = new RegExp(/^1[3456789]{1}[0-9]{9}$/);
							if (value === "") {
								callback(new Error("请输入手机号码"));
							} else if (!mobileNumRegx.test(value)) {
								callback(new Error("手机号码格式不正确"));
							} else {
								callback();
							}
						},
						trigger: ["blur", "change"],
					},
				],
				email: [
					{
						required: true,
						message: "请输入邮箱",
						trigger: ["blur", "change"],
					},
				],
				id_card: [
					{
						required: true,
						message: "请输入证件号",
						trigger: ["blur", "change"],
					},
				],
				school: [
					{
						required: true,
						message: "请输入学校名称",
						trigger: ["blur", "change"],
					},
				],
				university: [
					{
						required: true,
						message: "请输入所在学院",
						trigger: ["blur", "change"],
					},
				],
				major: [
					{
						required: true,
						message: "请输入专业",
						trigger: ["blur", "change"],
					},
				],
				grade: [
					{
						required: true,
						message: "请输入在读年级",
						trigger: ["blur", "change"],
					},
				],
				is_cima: [
					{
						required: true,
						message: "请选择身份",
						trigger: ["blur", "change"],
					},
				],
			},
			teacherRules: {
				name: [
					{
						required: true,
						message: "请输入姓名",
						trigger: ["blur", "change"],
					},
				],
				phone: [
					{
						required: true,
						validator: (rule, value, callback) => {
							let mobileNumRegx = new RegExp(/^1[3456789]{1}[0-9]{9}$/);
							if (value === "") {
								callback(new Error("请输入手机号码"));
							} else if (!mobileNumRegx.test(value)) {
								callback(new Error("手机号码格式不正确"));
							} else {
								callback();
							}
						},
						trigger: ["blur", "change"],
					},
				],
			},
			cardType:[
				{ id: '身份证', name: '身份证' },
				{ id: '港澳通行证', name: '港澳通行证' },
				{ id: '台胞证', name: '台胞证' },
				{ id: '护照', name: '护照' },
			],
			grades: [
				{ id: 1, name: '大一' },
				{ id: 2, name: '大二' },
				{ id: 3, name: '大三' },
				{ id: 4, name: '大四' },
			],
      dialogFormVisible: false,
      teacherData: [],
      isEdit: false,
      editIndex: 0,
      teacherDialog: false,
      teacherForm:{},
      isTeacherEdit: false,
      editTeacherIndex: 0,
      operateLoading: false,
      fileList: []
    };
  },
  props: ['round', 'label'],
  // 组件方法
  methods: {
    toDel() {
      this.fileInfo.url = ''
      this.uploadVideoProgressShow = false
    },
    async getView() {
      let res = await apiGetProcess(this.round.round_id, this.label)
      if (res.code === 200) {
        this.uploaded = res.data ? true : false
      }
      await this.getTeam()

    },
    async getTeam() {
      let res = await apiGetReportTeamData(this.round.round_id)
      if (res.code === 200) {
        this.form.parent_path = res.data.teamData.parent_path
        this.fileList = [{ url: res.data.teamData.parent_path, name: '家长同意书.docx' }]
        if(!this.memberArr.length) {
          this.memberArr = res.data.memberData
        }
      }
      for(let i = 0; i < this.memberArr.length; i++) {
        if(this.memberArr[i].grade) {
          this.memberArr[i].grade = Number(this.memberArr[i].grade)
        }
      }
    },
    async next() {
      this.subLoading = true
      let _data = this.fileInfo
      _data['file_source'] = 3;
      console.log('_data', _data, this.newProcess)
      if (this.newProcess.photo === undefined || this.newProcess.photo == '' || !this.newProcess.photo) {
        this.$message.error('请上传团队照片')
        this.subLoading = false
        return
      }
      let res = await apiUploadFileInfo(_data)
      if (res.code !== 200) {
        this.$message.error(res.message)
        this.subLoading = false
        return
      }
      this.newProcess.file_id = res.data.file_id

      if (this.newProcess.file_id === undefined || this.newProcess.file_id === '' || !this.newProcess.file_id) {
        this.$message.error('请上传作品')
        this.subLoading = false
        return
      }
      await apiSetProcess(this.round.round_id, this.label, this.newProcess)
      await this.getView()
      this.$Bus.$emit('reload_NowProcess');
      this.subLoading = false
    },
    beforeUpload(file) {
      if (this.uploadVideoProgressShow) {
        this.$error('当前状态不可上传文件');
        return false;
      }


      let that = this
      this.jindu = '';
      this.size = '';
      this.fileInfo['name'] = file.name
      this.fileInfo['type'] = file.name.split('.').pop()//文件格式
      this.fileInfo['size'] = (file.size / 1000000).toFixed(2) * 1000
      this.fileInfo['file_source'] = 3
      this.fileInfo['status'] = 2

      var url = URL.createObjectURL(file);
      var audioElement = new Audio(url);
      var duration;
      audioElement.addEventListener("loadedmetadata", function () {
        duration = audioElement.duration; //时长为秒，小数，182.36
        that.fileInfo['length'] = parseInt(duration)
      });


    },
    uploadBefore(file) {
      const isLt2G = file.file.size / 1024 / 1024 / 1024 <= 2;
      const isMP4 = file.file.type === 'video/mp4';
      if (!isMP4) {
        this.$message.error("上传视频只能是MP4格式!");
        return false
      }
      if (!isLt2G) {
        this.$message.error("上传文件大小不能超过 2GB!");
        return false
      }

      this.fileInfo.url = ''
      this.jindu = 0
      this.uploadVideoProgressShow = true
      this.uploadMutil(file);

    },
    async uploadMutil(a) {
      let that = this
      let res = await apiGetOssConfig()
      let config = {
        region: res.data.oss_region,
        //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
        accessKeyId: res.data.oss_key,
        accessKeySecret: res.data.oss_secret,
        bucket: res.data.oss_bucket,
      }
      let client = new OSS(config);
      let maxSize = a.file.size / 1000000;
      try {
        let uploadOptions = {
          parallel: 15,
          headers: { "x-oss-forbid-overwrite": true },
          progress: function (a) {
            if (that.chooseCancel) {
              that.tipMsg("已取消上传", "warning");
              throw new Error("取消上传");
            }
            that.jindu = a.toFixed(2);
            that.size = (maxSize * that.jindu).toFixed(2);
          },
        };
        let file_name = new Date().valueOf() + a.file.name;
        client.multipartUpload(this.round.year + "/normal/" + this.team.name + '/' + file_name, a.file, uploadOptions)
          .then(() => {
            that.$set(that.fileInfo, 'url', "https://" + config.bucket + "." + config.region + ".aliyuncs.com/" + this.round.year + "/normal/" + this.team.name + '/' + file_name)
          })
          .catch((e) => {
            if (e.name === "FileAlreadyExistsError") {
              this.$error("此文件名称已存在");
            }
            this.uploadVideoProgressShow = false
            console.log(e)
          });
      } catch (e) {
        this.uploadVideoProgressShow = false
        // 捕获超时异常。
        if (e.code === "ConnectionTimeoutError") {
          this.$message.error("文件上传超时,请重试");
          console.log("TimeoutError");
          // do ConnectionTimeoutError operation
        }
        console.log("error", e);
      }
    },
    handleAvatarSuccess(res) {
      if (res.code === 200) {
        this.$set(this.newProcess, 'entries_thumb', res.data.file.path)
        this.$message.success('上传成功')
      }
    },
    handleAvatarSuccess2(res) {
      if (res.code === 200) {
        this.$set(this.newProcess, 'photo', res.data.file.path)
        this.$message.success('上传成功')
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG或者PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforeFileUpload(file) {
      // 限制文件大小不超过100 MB
      const isLt100M = file.size / 1024 / 1024 <= 100;
      if (!isLt100M) {
        this.$message.error("上传文件大小不能超过100MB!");
      }
      return isLt100M;
    },
    handleFileSuccess(res) {
      if (res.code === 200) {
        this.form.parent_path = res.data.file.path
        this.$message.success('上传成功')
      }
    },
    handleExceed() {
      this.$message.warning('请先删除已上传的文件，再上传新文件');
    },

    handleRemove() {
      this.fileList = []
      this.form.parent_path = ''
    },
    
		toAddTeacher(){
			this.teacherForm = {}
			this.teacherDialog = true
		},
		del(i) {
			this.memberArr.splice(i, 1)
		},
		toEdit(data, i) {
			this.memberData = JSON.parse(JSON.stringify(data));
			this.editIndex = i;
			this.dialogFormVisible = this.isEdit = true;
		},
		toEditTeacher(data, i) {
			this.teacherForm = JSON.parse(JSON.stringify(data));
			this.editTeacherIndex = i;
			this.teacherDialog = this.isTeacherEdit = true;
		},
		delTeacher(i) {
			this.teacherData.splice(i, 1)
		},		
    setMember() {
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					if (this.isEdit) {
						this.memberArr.splice(this.editIndex, 1, this.memberData)
						this.editIndex = ''
						this.dialogFormVisible = this.isEdit = false
					} else {
						this.memberArr.push(this.memberData)
						this.dialogFormVisible = this.isEdit = false
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		setTeacher() {
			this.$refs.teacherForm.validate(async (valid) => {
				
				if (valid) {
					if (this.isTeacherEdit) {
						this.teacherData.splice(this.editIndex, 1, this.teacherForm)
						this.editTeacherIndex = ''
						this.teacherDialog = this.isEdit = false
					} else {
						this.teacherData.push(this.teacherForm)
						this.teacherDialog = this.isTeacherEdit = false
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
    async getDetail() {
      const res = await apiGetSemiFinalInfo();
      if (res.code === 200) {
        if(res.data.guide_teachers?.length && res.data.memberData?.length) {
          res.data.memberData.forEach(item => {
            if(item.grade) {
              item.grade = Number(item.grade)
            }
          })
          this.memberArr = res.data.memberData
          this.teacherData = res.data.guide_teachers
          this.uploaded = true
        }
      }
      await this.getTeam()
    },
		getGrade(grade) {
			const gradeName = this.grades.find(item => item.id === grade)
			return gradeName ? gradeName.name : ''
		},
    async submit() {
      if(!this.form.parent_path) {
        this.$message.error('请上传家长同意书')
        return
      }
      if(!this.teacherData.length) {
        this.$message.error('请添加指导老师')
        return
      }
      this.operateLoading = true
      let _data = {
        memberData: this.memberArr,
        guide_teachers: this.teacherData,
        parent_path: this.form.parent_path,
      }
      await apiSubSemiFinalInfo(_data).finally(() => {
        this.operateLoading = false
      }).then(() => {
        this.$message.success('提交成功')
        this.uploaded = true
      })
    },
    downloadTemplate() {
      window.open('https://api.gbc.cncima.com/storage/2026GBC中国大陆半决赛及决赛线下参赛承诺书.docx')
    }
  },
  async mounted() {
    // await this.getView()
    await this.getDetail()
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #733085;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: contain;
}
.download {
  margin-left: 10px;
  font-size: 14px;
  color: #72246C;
  cursor: pointer;
  text-decoration: underline;
}
</style>
